import React, { useState, useEffect } from 'react';
import { withRouter } from 'react-router-dom';
import PropTypes from 'prop-types';
import { Translate } from 'react-localize-redux';
import ArrowForwardIcon from '@material-ui/icons/ArrowForward';
import SearchBar from 'material-ui-search-bar';
import { FormControlLabel, Switch } from '@material-ui/core';
import StyledTable from './table/styled-table';
import CustomTableRow from './table/custom-table-row';
import CustomTableCell from './table/custom-table-cell';
import {
  getLicenseTypeLabelShort, getCompletedControlLabel, getLocationName,
} from '../utils';

const LicenseListDesktop = ({
  licenses, showZone, history, workPlan, workPlanList, showIsControlCompleted,
}) => {
  const [rows, setRows] = useState(licenses);
  const [hideCompleted, setHideCompleted] = useState(false);
  const [searchQuery, setSearchQuery] = useState('');

  useEffect(() => setRows(licenses), [licenses]);
  useEffect(updateRowsToDisplay, [searchQuery]);
  useEffect(updateRowsToDisplay, [hideCompleted]);

  function updateRowsToDisplay() {
    let licensesToDisplay = licenses;

    if (showIsControlCompleted && hideCompleted) {
      licensesToDisplay = licensesToDisplay.filter((license) => {
        const completedControl = getCompletedControlLabel(
          showIsControlCompleted,
          workPlan,
          workPlanList,
          license.sysId,
        );
        return !completedControl.startsWith('Ja');
      });
    }

    if (searchQuery !== '') {
      const searchedValLowerCase = searchQuery.toLowerCase();

      licensesToDisplay = licensesToDisplay.filter((license) => {
        const location = getLocationName(license).toLowerCase();
        const licensee = license.licensee.name.toLowerCase();
        return location.includes(searchedValLowerCase) || licensee.includes(searchedValLowerCase);
      });
    }

    setRows(licensesToDisplay);
  }

  function buildHeaderCells() {
    const headerCells = [
      <Translate id="license.location" />,
      <Translate id="license.licensee" />,
      <Translate id="license.licensetype" />,
    ];

    if (showIsControlCompleted) {
      headerCells.push(<Translate id="license.completedControl" />);
    }
    if (showZone) {
      headerCells.push(<Translate id="license.controlZone" />);
    }
    headerCells.push(''); // Column for arrow btn, is always shown

    return headerCells;
  }

  return (
    <>
      {showIsControlCompleted && (
        <FormControlLabel
          control={(
            <Switch
              checked={hideCompleted}
              onChange={(e) => {
                setHideCompleted(e.target.checked);
              }}
              name="hideCompleted"
              color="primary"
            />
          )}
          label="Vis kun bevillinger uten utført kontroll"
        />
      )}
      <SearchBar
        value={searchQuery}
        placeholder="Søk etter sted eller bevillingshaver"
        onChange={searchVal => setSearchQuery(searchVal)}
        onCancelSearch={() => setSearchQuery('')}
      />
      <StyledTable
        header={buildHeaderCells()}
        rowsPerPage={10}
      >
        {rows && rows.map((license, index) => {
          const completedControl = getCompletedControlLabel(
            showIsControlCompleted,
            workPlan,
            workPlanList,
            license.sysId,
          );

          return (
            <CustomTableRow
              key={license.sysId}
              onClick={() => history.push(`/${license.sysId}`)}
              odd={!(index % 2)}
            >
              <CustomTableCell>{getLocationName(license)}</CustomTableCell>
              <CustomTableCell>{license.licensee.name}</CustomTableCell>
              <CustomTableCell>{getLicenseTypeLabelShort(license.licenseType)}</CustomTableCell>
              {showIsControlCompleted && (
                <CustomTableCell>
                  {completedControl}
                </CustomTableCell>
              )}
              {showZone && (
                <CustomTableCell>
                  {(license.controlZone && license.controlZone.indexOf('sone') === 0)
                    ? license.controlZone.substring(4) : license.controlZone}
                </CustomTableCell>
              )}
              <CustomTableCell shrink>
                <ArrowForwardIcon color="primary" />
              </CustomTableCell>
            </CustomTableRow>
          );
        })}
      </StyledTable>
    </>
  );
};

LicenseListDesktop.defaultProps = {
  showZone: true,
  workPlan: null,
  workPlanList: [],
};

LicenseListDesktop.propTypes = {
  licenses: PropTypes.array.isRequired,
  showZone: PropTypes.bool,
  history: PropTypes.object.isRequired,
  workPlan: PropTypes.object,
  workPlanList: PropTypes.array,
  showIsControlCompleted: PropTypes.bool.isRequired,
};

export default withRouter((LicenseListDesktop));
